import React, { memo } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { contextMenu } from 'react-contexify';

import CommonTable from '../../../components/common-table/CommonTable';
import Tr from '../../../components/common-table/components/Tr';
import Th from '../../../components/common-table/components/Th';
import SonarTableContextMenu from '../../sonar-table/SonarTableContextMenu';
import TdCheckbox from '../../../components/common-table/components/TdCheckbox';
import Td from '../../../components/common-table/components/Td';
import TdDomain from '../../../components/common-table/components/TdDomain';
import TdValue from '../../../components/common-table/components/TdValue';
import { chooseDomain } from '../../../redux/sonar/sonarReducer';

const MENU_ID_SHOW = 'sonar-brand-table/ContextMenuShow';
const MENU_ID_HIDE = 'sonar-brand-table/ContextMenuHide';

const BrandTable = ({ domainEntry }) => {
  const { t } = useTranslation('sonar');

  return (
    <>
      <CommonTable
        rootClassName='brand-table'
        content={[domainEntry]}
        renderBody={(item) => (
          <BrandTableItem key={`TableRow-${item.domain}`} data={item} trendEvaluator={trendEvaluator} />
        )}>
        <Tr>
          <Th extraClasses='cell-btn'></Th>
          <Th extraClasses='cell-rank'>{t('rank')}</Th>
          <Th extraClasses='cell-title'>{t('company')}</Th>
          <Th>{t('interest')}</Th>
          <Th>{t('trust')}</Th>
          <Th>{t('engagement')}</Th>
          <Th>{t('relevanceStrength')}</Th>
          <Th>{t('relevanceBreadth')}</Th>
          <Th>{t('rivalry')}</Th>
          <Th>{t('reach')}</Th>
          <Th>{t('vitality')}</Th>
          <Th>{t('powerrank')}</Th>
        </Tr>
      </CommonTable>

      <SonarTableContextMenu id={MENU_ID_HIDE} hideLabel={t('hide')} />
      <SonarTableContextMenu id={MENU_ID_SHOW} hideLabel={t('show')} />
    </>
  );
};

const BrandTableItem = ({ data, trendEvaluator }) => {
  const { domain, companyName, isActive, inFocus, selected, marked, rank, companyLogo, myCompany } = data;
  const dispatch = useDispatch();

  const handleSelect = () => {
    dispatch(chooseDomain(domain));
  };

  const displayContextMenu = (event) => {
    contextMenu.show({
      id: isActive ? MENU_ID_HIDE : MENU_ID_SHOW,
      event,
      props: { domain },
    });
  };

  return (
    <Tr onContextMenu={displayContextMenu} isInactive={!isActive} isMarked={marked}>
      <TdCheckbox selected={selected} onSelect={handleSelect} />
      <Td extraClasses='cell-rank'>{rank}</Td>
      <TdDomain
        domain={domain}
        company={companyName}
        inFocus={inFocus}
        myCompany={myCompany}
        logo={companyLogo}
        isLeft
      />
      <TdValue data={data.interest} trendEvaluator={trendEvaluator} />
      <TdValue data={data.trust} trendEvaluator={trendEvaluator} />
      <TdValue data={data.passion} trendEvaluator={trendEvaluator} />
      <TdValue data={data.relevanceStrength} trendEvaluator={trendEvaluator} />
      <TdValue data={data.relevanceBreadth} trendEvaluator={trendEvaluator} />
      <TdValue data={data.friction} trendEvaluator={trendEvaluator} />
      <TdValue data={data.presence} trendEvaluator={trendEvaluator} />
      <TdValue data={data.energy} trendEvaluator={trendEvaluator} />
      <TdValue data={data.powerrank} trendEvaluator={trendEvaluator} />
    </Tr>
  );
};

function trendEvaluator(trend, score) {
  const ratio = trend / score;
  return ratio < 1 ? -1 : 1;
}

export default memo(BrandTable);
